var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.error)?_c('app-ad',{attrs:{"compact":"","outlined":""}},[_c('ad-script',{attrs:{"id":"bsa-native","script-id":"bsa-ad","src":"//m.servedby-buysellads.com/monetization.js"},on:{"script:error":function($event){_vm.error = true},"script:load":_vm.onLoad}})],1):_c('random-ad',{attrs:{"medium":_vm.medium}})
}
var staticRenderFns = []

export { render, staticRenderFns }